var render = function (_h,_vm) {var _c=_vm._c;return _c('h1',{staticClass:"ebx-result-title",class:[].concat(_vm.data.staticClass, _vm.data.class),style:(_vm.data.style)},[_vm._v(_vm._s(_vm.props.item.name))])}
var staticRenderFns = []

export { render, staticRenderFns }